import BackButton from "../../components/onboarding/back-button";

const Privacy = () => {
    return (
        <div style={{ fontSize: 24, padding: 14, lineHeight: 1.3 }}>
            <BackButton />
            <h1 style={{ fontSize: 34, fontWeight: 800, marginTop: 50 }}>개인정보처리방침</h1>
            <br />
            <br />
            <div style={{ fontSize: 18 }}>
                feople은 이용자의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 다음과 같이
                개인정보 처리방침을 수립·공개하며, 본 개인정보 처리방침을 홈페이지 첫 화면에 공개함으로써 이용자들이
                언제나 용이하게 보실 수 있도록 조치하고 있습니다. 개인정보 처리방침은 정부의 법률 및 지침 변경이나
                회사의 내부 방침 변경 등으로 인하여 수시로 변경될 수 있고, 이에 따른 개인정보 처리방침의 지속적인 개선을
                위하여 필요한 절차를 정하고 있습니다. 이용자들께서는 사이트 방문 시 수시로 확인하시기 바랍니다. feople의
                개인정보 처리방침은 다음과 같은 내용을 담고 있습니다.
            </div>
            <br />
            <br />
            <br /> 1. 개인정보 수집에 대한 동의 <br />
            2. 수집하는 개인정보 항목 및 수집방법 <br />
            3. 개인정보의 수집 및 이용목적 <br />
            4. 수집하는 개인정보의 보유 및 이용기간 <br />
            5. 개인정보의 파기 절차 및 방법 <br />
            6. 수집한 개인정보의 공유 및 제공 <br />
            7. 이용자 자신의 개인정보 관리(열람,정정,삭제 등)에 관한 사항 <br />
            8. 개인정보보호를 위한 기술적/관리적 대책 <br />
            9. 개인정보 관련 의견수렴 및 불만처리에 관한 사항 <br />
            10. 개인정보 보호책임자 및 담당자의 소속-성명 및 연락처 <br />
            11. 이용자 권리와 그 행사방법 <br />
            12. 권익침해 구제방법 <br />
            13. 고지의 의무
            <br />
            <br />
            1. 개인정보 수집에 대한 동의
            <br />
            <br /> feople은 이용자들이 회사의 개인정보수집이용 동의 또는 이용약관의 내용에 대하여 「동의」버튼 또는
            「취소」버튼을 클릭할 수 있는 절차를 마련하여, 「동의」버튼을 클릭하면 개인정보 수집에 대해 동의한 것으로
            봅니다. <br />
            <br />
            2. 수집하는 개인정보의 항목 및 수집방법
            <br />
            <br /> 가. 수집 항목 feople은 이용자들이 회원서비스를 이용하기 위해 회원으로 가입하실 때 서비스 제공을 위한
            필수/선택적인 정보들을 온라인상에서 입력 받고 있습니다. (필수) 회원 가입 정보 : 닉네임, 가족 내 역할(구성원
            역할) 회원제 서비스 이용에 따른 본인 확인 절차에 이용 시 수집 정보 : 이름 <br />
            <br />
            나. 수집 방법 feople은 다음과 같은 방법으로 개인정보를 수집합니다. 앱 내 회원가입 페이지를 통한 닉네임 입력
            및 가족 구성원 역할 선택 제공 <br />
            <br />
            3. 개인정보의 수집 및 이용 목적
            <br />
            <br /> feople은 이용자의 사전 동의 없이는 이용자의 개인 정보를 수집하지 않으며, 수집된 정보는 아래와 같이
            이용하고 있습니다. <br />
            <br />
            가. 신규 서비스의 개발 이용자들이 제공한 개인정보를 바탕으로 보다 더 유용한 서비스를 개발할 수 있습니다.
            회사는 신규 서비스 개발이나 컨텐츠의 확충 시에 기존 이용자들이 회사에 제공한 개인정보를 바탕으로 개발해야 할
            서비스의 우선 순위를 보다 더 효율적으로 정하고, 회사는 이용자들이 필요로 할 컨텐츠를 합리적으로 선택하여
            제공할 수 있습니다. <br />
            <br />
            나. 회원관리 회원제 서비스 이용에 따른 본인확인, 개인 식별, 가입 의사 확인 다. 앱 내 사용자 그룹 내 식별자로
            활용 가족 단위로 사용하게 되는 앱 기능 특성상, 가족 구성원의 역할이 무엇인지, 닉네임이 무엇인지로 서로 간
            신원확인을 할 수 있다. <br />
            <br />
            4. 수집하는 개인정보의 보유 및 이용기간 <br />
            <br />
            feople은 이용자의 개인정보를 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 단,
            다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존합니다. <br />
            <br />
            가. 관련법령에 의한 정보보유 사유 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의
            소비자보호에 관한 법률) <br />
            <br />
            5. 개인정보의 파기 절차 및 방법 <br />
            <br />
            feople은 귀중한 회원의 개인정보를 안전하게 처리하며, 유출의 방지를 위하여 다음과 같은 방법을 통하여
            개인정보를 파기합니다. <br />
            <br />
            가. 파기절차 이용자가 서비스 이용 등을 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우
            별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간
            저장된 후 파기됩니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른
            목적으로 이용되지 않습니다. <br />
            <br />
            나. 파기방법 종이에 출력된 개인정보 : 분쇄기로 분쇄하거나 소각 전자적 파일 형태로 저장된 개인정보 : 기록을
            재생할 수 없는 기술적 방법을 사용하여 삭제 <br />
            <br />
            6. 수집한 개인정보의 공유 및 제공 <br />
            <br />
            feople은 이용자들의 개인정보를 동의받은 범위 내에서 사용하며, 이용자의 사전 동의 없이는 동 범위를 초과하여
            이용하거나 원칙적으로 이용자의 개인정보를 외부에 공유 및 제공하지 않습니다. 다만, 아래의 경우에는 예외로
            합니다. 이용자들이 사전에 공유 및 제공에 동의한 경우 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진
            절차와 방법에 따라 수사기관의 요구가 있는 경우 <br />
            <br />
            7. 이용자 자신의 개인정보 관리
            <br />
            <br />
            (열람,정정,삭제 등)에 관한 사항 회원님이 원하실 경우 언제라도 당사에서 개인정보를 열람하실 수 있으며 보관된
            필수 정보를 수정하실 수 있습니다. 또한 회원 가입 시 요구된 필수 정보 외의 추가 정보는 언제나 열람, 수정,
            삭제할 수 있습니다. 회원님의 개인정보 변경 및 삭제와 회원탈퇴는 당사의 서비스의 메뉴에서 로그인(Login) 후
            이용하실 수 있습니다. <br />
            <br />
            8. 개인정보보호를 위한 기술적/관리적 대책
            <br />
            <br /> feople은 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조, 또는 훼손되지 않도록
            안전성 확보를 위하여 다음과 같은 관리적, 기술적, 물리적 대책을 강구하고 있습니다. <br />
            <br />
            가. 관리적 조치 : 내부관리계획 수립. 시행, 정기적 교육 등 <br />
            <br />
            나. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화,
            보안프로그램 설치 다. 물리적 조치 : 전산실, 자료보관실 등의 접근통제 feople은 는 이용자 개인의 실수나
            기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. <br />
            <br />
            9. 개인정보 관련 의견수렴 및 불만처리에 관한 사항
            <br />
            <br /> feople은 개인정보보호와 관련하여 이용자 여러분들의 의견을 수렴하고 있으며 불만을 처리하기 위하여 모든
            절차와 방법을 마련하고 있습니다. 이용자들은 하단에 명시한 "13. 개인정보 관리책임자 및 담당자의 소속-성명 및
            연락처"항을 참고하여 전화나 메일을 통하여 불만사항을 신고할 수 있고, feople은 이용자들의 신고사항에 대하여
            신속하고도 충분한 답변을 해 드릴 것입니다. <br />
            <br />
            10. 개인정보 보호책임자 및 담당자의 소속-성명 및 연락처 <br />
            <br />
            feople은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만처리 및 피해구제
            등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.
            <br />
            <br /> 이 름 : 이진혁 <br />
            소속 / 직위 : 대표 <br />
            E-M A I L : wlsgur0218@naver.com <br />전 화 번 호 : 010-3954-8120 <br />
            <br />
            11. 이용자의 권리와 그 행사방법
            <br />
            <br /> 가. 이용자가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를
            이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게
            지체 없이 통지하여 정정이 이루어지도록 하겠습니다. <br />
            <br />
            나. feople은 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 "수집하는 개인정보의 보유 및
            이용기간"에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다. <br />
            <br />
            12. 권익침해 구제방법 <br />
            <br />
            이용자는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다. 아래의 기관은
            회사와는 별개의 기관으로서, 회사의 자체적인 개인정보 불만처리, 피해구제 결과에 만족하지 못하시거나 보다
            자세한 도움이 필요하시면 문의하여 주시기 바랍니다
            <br /> ▶ 개인정보 침해신고센터 (한국인터넷진흥원 운영) <br />- 소관업무 : 개인정보 침해사실 신고, 상담 신청
            <br />- 홈페이지 : [privacy.kisa.or.kr](http://privacy.kisa.or.kr/) <br />- 전화 : (국번없이) 118 <br />-
            주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고센터
            <br />
            <br />▶ 개인정보 분쟁조정위원회 <br />- 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결) <br />
            - 홈페이지 : [www.kopico.go.kr](http://www.kopico.go.kr/) - 전화 : (국번없이) 1833-6972 <br />- 주소 :
            (03171)서울특별시 종로구 세종대로 209 정부서울청사 4층 ▶ 대검찰청 사이버수사과 :
            [http://www.spo.go.kr](http://www.spo.go.kr/) ▶ 경찰청 사이버안전국 :
            [http://cyberbureau.police.go.kr](http://cyberbureau.police.go.kr/) <br />
            <br />
            13. 고지의 의무
            <br />
            <br /> 현 개인정보처리방침의 내용은 정부의 정책 또는 보안기술의 변경에 따라 내용의 추가 삭제 및 수정이 있을
            시에는 홈페이지의 '공지사항'을 통해 고지할 것입니다. <br />
            <br />
            개인정보처리방침 시행일자: 2023-11-23 <br />
            개인정보처리방침 변경일자: 2023-11-23
        </div>
    );
};
export default Privacy;
